// Store & actions
import useSessionStore from '../../store/session';
import useComputedRoutesStore from '../../store/computedRoutes';
// Components
import Page from '../../../common-utils/components/structure/page/Page';
import CardDeck from '../../../common-utils/components/renders/cardDeck/CardDeck';
import HomeCard from '@/app/modules/home/components/HomeCard';
// Common
import RouteUrls from '@/app/root/enums/RouteUrls';
import getRoutesToRender from '../../../common-utils/functions/getRoutesToRender';

/**
 * @returns {JSX} CustomPayHome
 */
function CustomPayHome() {
    // Store
    const session = useSessionStore(s => s.session);
    const computedRoutes = useComputedRoutesStore(s => s.computedRoutes);

    return (
        <Page>
            <Page.Header route={RouteUrls.HOME} routeBase={RouteUrls.HOME} />
            <Page.Body dataCy='page-home'>
                <CardDeck
                    cardsProps={getRoutesToRender(computedRoutes, session.permissions)}
                    component={(route) => <HomeCard route={route} key={route.key} />}
                    cardsNumberPerRow={3}
                />
            </Page.Body>
        </Page>
    );
}

export default CustomPayHome;